import { Component, OnInit } from '@angular/core'; 
import { ShowHideLoaderService } from '../show-hide-loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  showLoader:boolean=false;
  constructor(private loaderService:ShowHideLoaderService) {

    this.loaderService.loader.subscribe(show=>{ 
      this.showLoader=show;
    });
   }

  ngOnInit(): void {
   
  }

}
